module.exports = __webpack_public_path__ + "static/Eye&CheekPalette-a21f3e9383955ed41061b0aa72480e6e.jpg";